import Vue from 'vue'
import get from 'lodash/get'

import * as Types from './types'

export default {
  /**
   * @param {NotificationStore} state
   * @param {VvNotification} notification
   */
  [Types.ADD_NOTIFICATION](state, notification) {
    if (!notification) return

    Vue.set(state.notifications, [notification.id], notification)
  },
  /**
   * @param {NotificationStore} state
   * @param {VvNotification} notificationId
   */
  [Types.SET_NOTIFICATION_SEEN](state, notificationId) {
    if (!notificationId) return

    /**
     * @type {VvNotification}
     */
    const notification = get(state.notifications, [notificationId], null)

    if (!notification) return

    notification.seen = true

    Vue.set(state.notifications, notificationId, notification)
  },
  /**
   * @param {NotificationStore} state
   * @param {VvNotification} notificationId
   */
  [Types.SET_NOTIFICATION_TOASTED](state, notificationId) {
    if (!notificationId) return

    /**
     * @type {VvNotification}
     */
    const notification = get(state.notifications, [notificationId], null)

    if (!notification) return

    notification.toast.shown = true

    Vue.set(state.notifications, notificationId, notification)
  },
  /**
   * @param {NotificationStore} state
   * @param {VvNotification} notifications
   */
  [Types.SET_NOTIFICATIONS](state, notifications) {
    notifications.forEach(notification => {
      Vue.set(state.notifications, notification.id, notification)
    })
  }
}
